import { getType } from 'typesafe-actions'
import { cloneDeep } from 'lodash'

import * as actions from './actions'
import { StoreState, ReportAction, Filter, DataDetail } from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { Event } from '../../types/event'
import { sortingActivityList } from './function'

const initList = {
  Total: 0,
  List: [],
}

const initPMR = {
  PercentPMR: 0,
}

const initFilter = {
  ProjectCode: [],
  ProjectTypeID: 0,
} as Filter

const initEvent = {
  IsLoading: false,
  MessageSuccess: undefined,
  SubmitError: undefined,
  SubmitSuccess: false,
  SubmitType: undefined,
} as Event

const initDetailt = {
  ProjectCode: '',
  ProjectNameEN: '',
  ProjectNameTH: '',
  MCVendorCode: '',
  NumOfCheckUnit: 0,
  PercentOfFail: 0,
  Status: '',
  TotalUnit: 0,
  VendorName: '',
  FirstCheck: {
    NumOfDefect: 0,
    NumOfSansiriDefect: 0,
  },
  PMR: {
    NumOfFixLaterDefect: 0,
    NumOfFixedDefect: 0,
    NumOfNoFixConditionDefect: 0,
    NumOfPMRDefect: 0,
    NumOfPMRSansiriDefect: 0,
  },
  QCCheckAdd: {
    NumOfDefect: 0,
    NumOfSansiriDefect: 0,
  },
  QCCheckFail: {
    NumOfDefect: 0,
    NumOfSansiriDefect: 0,
  },
  QCCheckPass: {
    NumOfDefect: 0,
    NumOfSansiriDefect: 0,
  },
  WarrantyStart: '',
  WarrantyEnd: '',
  QCEndDate: '',
  QCStartDate: '',
} as DataDetail

const initialState: StoreState = {
  Event: cloneDeep(initEvent),
  DataList: cloneDeep(initList),
  Filter: cloneDeep(initFilter),
  ClearFilter: cloneDeep(initFilter),
  DataDetail: cloneDeep(initDetailt),
  sorting: {
    name: 'ProjectCode',
    type: 'asc',
  },
  PmrEvent: cloneDeep(initEvent),
  PMR: cloneDeep(initPMR),
  DataExport: [],
  ExportEvent: cloneDeep(initEvent),
}

export default function(
  state: StoreState = initialState,
  action: ReportAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.getReportListAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        draft.DataList = cloneDeep(initList)
        break
      case getType(actions.getReportListAction.success):
        draft.Event.IsLoading = false
        const data = action.payload.ResponseData
        const dataSort = sortingActivityList(
          data.List,
          draft.sorting.type,
          draft.sorting.name
        )
        draft.DataList = {
          Total: data.Total,
          List: dataSort,
        }
        break

      case getType(actions.getReportDetailAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        draft.DataDetail = cloneDeep(initDetailt)
        break
      case getType(actions.getReportDetailAction.success):
        draft.Event.IsLoading = false
        draft.DataDetail = action.payload.ResponseData
        break
      case getType(actions.getReportListAction.failure):
      case getType(actions.getReportDetailAction.failure):
      case getType(actions.saveCertAction.failure):
      case getType(actions.cancelCertAction.failure):
        draft.Event.IsLoading = false
        draft.Event.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.sortingTask):
        const sorting = state.sorting
        const params = action.payload
        if (sorting.name === params.name) {
          draft.sorting.type = sorting.type === 'asc' ? 'desc' : 'asc'
        } else {
          draft.sorting.name = params.name
          draft.sorting.type = 'asc'
        }
        if (params.sort != null) {
          draft.sorting.type = params.sort
        }

        const list = sortingActivityList(
          draft.DataList.List,
          draft.sorting.type,
          draft.sorting.name
        )
        draft.DataList.List = list
        break

      case getType(actions.updateFilter):
        draft.Filter = { ...action.payload }
        break
      case getType(actions.clearFilter):
        draft.Filter = cloneDeep({ ...initFilter })
        break

      case getType(actions.getPercentPMRAction.request):
        draft.PmrEvent = cloneDeep(initEvent)
        draft.PmrEvent.IsLoading = true
        draft.PMR = cloneDeep(initPMR)
        break
      case getType(actions.getPercentPMRAction.success):
        draft.PmrEvent.IsLoading = false
        draft.PMR = action.payload.ResponseData
        break

      case getType(actions.setPercentPMRAction.request):
        draft.PmrEvent = cloneDeep(initEvent)
        draft.PmrEvent.IsLoading = true
        break

      case getType(actions.setPercentPMRAction.success):
        draft.PmrEvent.IsLoading = false
        draft.PmrEvent.SubmitError = undefined
        draft.PmrEvent.SubmitSuccess = true
        draft.PmrEvent.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.getPercentPMRAction.failure):
      case getType(actions.setPercentPMRAction.failure):
        draft.PmrEvent.IsLoading = false
        draft.PmrEvent.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.saveCertAction.request):
      case getType(actions.cancelCertAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        break
      case getType(actions.saveCertAction.success):
      case getType(actions.cancelCertAction.success):
        draft.Event.IsLoading = false
        draft.Event.SubmitError = undefined
        draft.Event.SubmitSuccess = true
        draft.Event.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.exportReportListAction.request):
        draft.ExportEvent = cloneDeep(initEvent)
        draft.ExportEvent.IsLoading = true
        draft.DataExport = []
        break
      case getType(actions.exportReportListAction.success):
        draft.ExportEvent.IsLoading = false
        if (action.payload.ResponseData) {
          draft.DataExport = action.payload.ResponseData.List
        }
        break
      case getType(actions.exportReportListAction.failure):
        draft.ExportEvent.IsLoading = false
        draft.ExportEvent.SubmitError = parseErrorMessage(action.payload)
        break

      default:
        return state
    }
  })
}
